export default () => ({
    isOpen: false,
    menu: null,
    subMenu: null,
    toggle(show) {
        if (show) {
            this.isOpen = show;
        }
        else {
            this.isOpen =  !this.isOpen;
        }

        if (!this.isOpen) {
            this.subMenu = null;
            this.menu = null;
        } 

        Grebify.noScroll(!show);
    },
    setMenu(index) {
        this.menu = index;
    },
    setSubMenu(index) {
        this.subMenu = index;
    }
});